export const ROLE_WEB_EDITOR = 'WebEditor'
export const ROLE_COMPETITOR_ANALYST = 'CompetitorAnalyst'
export const ROLE_ROUTING_TOOL_EDITOR = 'RoutingToolEditor'
export const ROLE_CMS_EDITOR = 'CmsEditor'



// WEBPACK FOOTER //
// ./src/util/constants.js